import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const SubMenuControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;


	const [users, setUsers] = useState([
		{
			sub_menu_name: '',
			sub_menu_position: '',
			sub_menu_link: '',
			status:''
		}
	])

	const handleAddInput = () => {
		setUsers([...users, { sub_menu_name: "", sub_menu_position: "", sub_menu_link: "",status: "" }]);
	};

	const handleChange = (event, index) => {
		let { name, value } = event.target;
		let onChangeValue = [...users];
		onChangeValue[index][name] = value;
		setUsers(onChangeValue);
	};

	const handleDeleteInput = (index) => {
		const newArray = [...users];
		newArray.splice(index, 1);
		setUsers(newArray);
	};




	const history = useHistory();
	const [data, setData] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState([]);

	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");



	const [inputFields, setInputFields] = useState([
		{ name: '', age: '' }
	])


	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchurl', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			//.then(res =>console.log(res.data))
			.then(res => setUrlRes(res.data))
			.catch(err => console.log(err));
	}, [])


	const handleEditSubmit = (e) => {

		// console.log('hi');

		
		e.preventDefault();

		axios.post(API_BASE_URL + '/addsubmenu', { sub_menus: JSON.stringify(users), menu_id: param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response);
			// // 	console.log(response.data.message);
			//  })


			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					return history.push("/hr-menu");
				}, 3000);

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {

			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});

	};



	useEffect(() => {
		axios.get(API_BASE_URL + '/showsubmenu/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			.then(res => setUsers(res.data))
			.catch(err => console.log(err));
	}, [])




	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">Add SubMenu</h3>
										</div>
										<div className="card-body">


											<form onSubmit={handleEditSubmit}>


												{users.map((item, index) => {
													return (
														<div class="row" key={index}>
															<div className="col-md-2 col-sm-6">
																<div className="form-group">
																	<input type="text" className="form-control" name="sub_menu_name"
																		placeholder="Sub Menu Name" value={item.sub_menu_name}
																		onChange={(event) => handleChange(event, index)} />
																</div>
															</div>

															<div className="col-md-2 col-sm-6">
																<div className="form-group">
																	<input type="text" className="form-control" name="sub_menu_position"
																		placeholder="Sub Menu Position" value={item.sub_menu_position}
																		onChange={(event) => handleChange(event, index)} />
																</div>
															</div>

															<div className="col-md-2 col-sm-6">
																<div className="form-group">
																	<select name="sub_menu_link" id="menu_link" className="form-control custom-select" value={item.sub_menu_link} onChange={(event) => handleChange(event, index)}>
																		<option value="" disabled>Select SubMenu Link</option>
																		<option></option>
																		{urlres.map(option => (
																			<option key={option.id} value={option.id}>
																				{option.link}
																			</option>
																		))}
																	</select>
																	{/* <input type="text" className="form-control" name="sub_menu_link" 
						placeholder="Sub Menu Link" value={item.sub_menu_link}
						onChange={(event) => handleChange(event, index)}/> */}
																</div>
															</div>


															<div className="col-md-2 col-sm-6">
																<div className="form-group">
																{/* <label className="form-label">Status <span className="form-required">*</span></label> */}
																	<select name="status" id="status" className="form-control custom-select" value={item.status} onChange={(event) => handleChange(event, index)} >
																		<option value={1}>Active</option>
																		<option value={0}>InActive</option>
																	</select>
																</div>
															</div>



															<div className="col-md-2 col-sm-6">
																<div className="form-group">
																	{users.length > 1 && (
																		<button className="btn btn-primary" onClick={() => handleDeleteInput(index)}>Delete</button>
																	)}

																	{index === users.length - 1 && (
																		<button className="btn btn-success" onClick={() => handleAddInput()}>Add</button>
																	)}
																</div>
															</div>





														</div>






													)
												})}












												{/* <div className="body"> {JSON.stringify(users)} </div> */}

												<div class="row">

													<div className="col-md-2 col-sm-6">
														<div className="form-group">

															<button type="submit" className="btn btn-primary">
																Add SubMenu
															</button>

														</div>
													</div>


												</div>
											</form>




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(SubMenuControl);